export const THEME_LIGHT = "light";
export const THEME_DARK = "dark";
export const THEME_STORAGE_KEY = "logimind.theme";

export function normalizeTheme(value) {
  return value === THEME_DARK ? THEME_DARK : THEME_LIGHT;
}

export function readStoredTheme() {
  try {
    return normalizeTheme(localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return THEME_LIGHT;
  }
}

export function applyTheme(theme) {
  const next = normalizeTheme(theme);
  if (typeof document !== "undefined") {
    document.documentElement.dataset.theme = next;
    document.documentElement.classList.toggle("theme-dark", next === THEME_DARK);
    document.documentElement.style.colorScheme = next;
  }
  try {
    localStorage.setItem(THEME_STORAGE_KEY, next);
  } catch {
    /* ignore */
  }
  return next;
}

applyTheme(readStoredTheme());
